import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPisces = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.66663 29.3334C11.8264 27.2693 14 22.9616 14 17.9819C14 13.0313 11.8517 8.74479 8.72178 6.66675M27.3333 29.3334C24.1735 27.2693 22 22.9616 22 17.9819C22 13.0313 24.1482 8.74479 27.2781 6.66675M27.3333 18.0001H8.66663",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgPisces;
